import React, { memo } from "react"

import styled from "styled-components"

import { colors } from "@izettle/otto"

import { selectorStates } from "./base"

const MARKER_SIZE = 22
const MARKER_SIZE_ACTIVE = 12
const CONTAINER_SIZE = 24
const MARKER_SCALE_ACTIVE = MARKER_SIZE_ACTIVE / MARKER_SIZE

const RadioMarker = styled.div`
  position: absolute;
  height: ${MARKER_SIZE}px;
  width: ${MARKER_SIZE}px;
  border-radius: 50%;
  background: currentColor; /* background is set via color on the RadioContainer */

  top: 50%;
  left: 50%;
  transition: transform 0.12s ease-in-out;
  transform: translate(-50%, -50%) scale(1);
`

const RadioContainer = styled.div`
  position: relative;

  flex-shrink: 0;
  height: ${CONTAINER_SIZE}px;
  width: ${CONTAINER_SIZE}px;
  border-radius: 50%;

  /* Default */
  color: ${colors.selector.base};

  transition: background-color 0.2s ease-in-out;
  background-color: ${colors.selector.initial.default};

  ${selectorStates.hover} {
    background-color: ${colors.selector.initial.hover};
  }

  ${selectorStates.active} {
    background-color: ${colors.selector.initial.active};
  }

  /* Selected */
  ${selectorStates.checked} {
    > ${RadioMarker} {
      transform: translate(-50%, -50%) scale(${MARKER_SCALE_ACTIVE});
    }

    color: ${colors.selector.base};
    background-color: ${colors.selector.selected.default};

    ${selectorStates.hover} {
      background-color: ${colors.selector.selected.hover};
    }

    ${selectorStates.active} {
      background-color: ${colors.selector.selected.active};
    }
  }

  /* Invalid */
  ${selectorStates.invalid} {
    background-color: ${colors.selector.error.default};

    ${selectorStates.hover} {
      background-color: ${colors.selector.error.hover};
    }

    ${selectorStates.active} {
      background-color: ${colors.selector.error.active};
    }
  }

  /* Disabled */
  ${selectorStates.disabled} {
    color: ${colors.selector.disabled.base};
    background-color: ${colors.selector.disabled.accent} !important;
  }

  ${selectorStates.disabledChecked} {
    color: ${colors.selector.disabledSelected.accent};
    background-color: ${colors.selector.disabledSelected.base} !important;
  }

  /* Focus */
  &:before {
    pointer-events: none;
    content: "";
    position: relative;
    display: block;
    box-sizing: border-box;
    border: 1px solid;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    z-index: -1;
    top: -6px;
    left: -6px;

    border-color: ${colors.selector.focus.border};
    background-color: ${colors.selector.focus.background};

    transition: opacity 0.2s ease-in-out;
    opacity: 0;
  }

  ${selectorStates.focus}:before {
    opacity: 1;
  }
`

export const RadioStyles = memo(() => (
  <RadioContainer>
    <RadioMarker />
  </RadioContainer>
))
